"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipengineCarrierNames = void 0;
var ShipengineCarrierNames;
(function (ShipengineCarrierNames) {
    // Royal Mail, DPD, DHL, Evri
    ShipengineCarrierNames["ROYAL_MAIL"] = "royal_mail";
    ShipengineCarrierNames["DPD"] = "dpd";
    ShipengineCarrierNames["DHL"] = "dhl_express_uk";
    ShipengineCarrierNames["DHL_PARCEL_UK"] = "dhl_parcel_uk";
    ShipengineCarrierNames["EVRI"] = "evri";
    ShipengineCarrierNames["YODEL"] = "yodel";
    ShipengineCarrierNames["FEDEX_UK"] = "fedex_uk";
    ShipengineCarrierNames["TNT_UK"] = "tnt";
    ShipengineCarrierNames["IN_POST"] = "inPost";
    ShipengineCarrierNames["PARCEL_FORCE"] = "parcelForce";
})(ShipengineCarrierNames = exports.ShipengineCarrierNames || (exports.ShipengineCarrierNames = {}));
